import React from 'react';
import styled from 'styled-components';
import MotifProgressBar from '@ey/motif-react-wrapper/ProgressBar';

export default function ProgressLoader(props) {
	const {id, className, show} = props;
	return <StyledMotifProgressLoader id={id} className={className} show={show} hideLabel={true} />;
}

const StyledMotifProgressLoader = styled(MotifProgressBar)``;
